import { Actions } from '@ngrx/effects';
import { catchError, switchMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { EffectsBase } from '../../../../shared/src/lib/core/store/effects-base';
import {
  fetchCurrencyForTenant,
  fetchCurrencyForTenant_Success,
  fetchUser,
  fetchUser_Success,
} from './app.actions';
import { ContactService } from 'projects/shared/src/lib/core/services/contact.service';
import { UserService } from 'projects/shared/src/lib/core/services/user.service';

@Injectable()
export class AppEffects extends EffectsBase {
  fetchUser$ = this.createEffect(
    fetchUser,
    switchMap(() => {
      return this.contactService.getContact().pipe(
        switchMap((user) => {
          if (user && user.userId) {
            localStorage.setItem('USER_ID', user.userId);
            localStorage.setItem('USER_EMAIL', user.email);
          }
          return [fetchUser_Success({ user: user })];
        }),
      );
    }),
  );

  fetchCurrencyForTenant$ = this.createEffect(
    fetchCurrencyForTenant,
    switchMap(() => {
      return this.userService.getCurrencyForTenant().pipe(
        switchMap((currency) => [fetchCurrencyForTenant_Success({ currency })]),
        catchError(() =>
          of(
            fetchCurrencyForTenant_Success({
              currency: { id: '', currencyName: '', currencyCharacter: '' },
            }),
          ),
        ),
      );
    }),
  );

  constructor(
    private userService: UserService,
    private contactService: ContactService,
    override actions$: Actions,
  ) {
    super(actions$);
  }
}
